export default class FormOutputMessage {
  init() {
    this.wpcf7Elm = document.querySelectorAll('.wpcf7');

    if (!this.wpcf7Elm) {
      return;
    }

    this.wpcf7Elm.forEach((wpcf7) => {
      wpcf7.addEventListener('wpcf7submit', () => {
        setTimeout(() => {
          this.replaceOutputMessage(wpcf7);
        }, 200);
      });
    });
  }

  replaceOutputMessage(wpcf7) {
    this.successMessage = wpcf7.querySelector('.wpcf7-response-output');
    this.messageOrigin = this.successMessage.innerText;

    this.text = this.messageOrigin.replace('[br]', '<br>');

    this.successMessage.innerHTML = this.text;
  }
}
